import React from "react";
import ChatHeader from "./ChatHeader";
import WelcomeScreen from "./WelcomeScreen";
import ChatMessages from "./ChatMessages";
import ChatFooter from "./ChatFooter";

function ChatWindow({ updateActivity, fullscreen, isMobile, toggleFullscreen, ...props }) {

    const getWindowStyles = () => {
        const baseStyles = {
            position: "fixed",
            backgroundColor: "#fff",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
            zIndex: fullscreen ? 1050 : 1040,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            transition: "all 0.3s ease-in-out"
        };

        if (fullscreen) {
            return {
                ...baseStyles,
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                width: "100vw",
                height: "100vh",
                borderRadius: "0",
                zIndex: 1050
            };
        }

        if (isMobile) {
            return {
                ...baseStyles,
                bottom: "100px",
                right: "15px",
                left: "15px",
                width: "auto",
                height: "70vh",
                maxHeight: "600px",
                borderRadius: "12px"
            };
        }

        return {
            ...baseStyles,
            top: "100px",
            right: "25px",
            width: "380px",
            height: "600px",
            borderRadius: "12px"
        };
    };

    const styles = {
        chatWindow: getWindowStyles(),
        chatContainer: {
            flex: 1,
            overflowY: "auto",
            padding: "15px",
            backgroundColor: "#f8f9fa"
        }
    };

    const overlayStyles = fullscreen && isMobile ? {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        zIndex: 1049
    } : null;

    return (
        <>
            {overlayStyles && <div style={overlayStyles} />}

            <div
                style={styles.chatWindow}
                onClick={updateActivity}
                onMouseMove={updateActivity}
                onKeyDown={updateActivity}
            >
                <ChatHeader
                    isAuthenticated={props.isAuthenticated}
                    conversation={props.conversation}
                    clearChat={props.clearChat}
                    summarizeConversation={props.summarizeConversation}
                    toggleMinimize={props.toggleMinimize}
                    toggleFullscreen={toggleFullscreen}
                    fullscreen={fullscreen}
                    isMobile={isMobile}
                />

                {props.showWelcome ? (
                    <WelcomeScreen
                        isLoading={props.isLoading}
                        authError={props.authError}
                        isAuthenticated={props.isAuthenticated}
                        startChat={props.startChat}
                        email={props.email}
                        guid={props.guid}
                    />
                ) : (
                    <>
                        <ChatMessages
                            conversation={props.conversation}
                            onMarkMessagesRead={props.markMessagesAsRead}
                            isLoading={props.isLoading}
                            isStreaming={props.isStreaming}
                            mcpLoadingState={props.mcpLoadingState}
                            suggestedResponses={props.suggestedResponses}
                            onSuggestedResponse={props.handleSuggestedResponse}
                            streamingMessageIndex={props.streamingMessageIndex}
                            isDownloading={props.isDownloading}
                        />
                        <ChatFooter
                            input={props.input}
                            setInput={props.setInput}
                            isLoading={props.isLoading}
                            handleSubmit={props.handleSubmit}
                        />
                        <div style={{
                            fontSize: "11px",
                            color: "#6c757d",
                            textAlign: "center",
                            padding: "8px 15px",
                            backgroundColor: "#f8f9fa",
                            borderTop: "1px solid #e9ecef"
                        }}>
                            Responses are generated automatically and I am still learning. Please double check key details where needed.
                        </div>
                    </>
                )}
            </div>
        </>
    );
}

export default ChatWindow;